import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared.module';
import { CapFormFieldComponentComponent } from './cap-form-field-component/cap-form-field-component.component';
import { ShiftDailyCapComponent } from './shift-daily-cap.component';

const routes: Routes = [
  {
    path: '',
    component: ShiftDailyCapComponent,
  },
];

@NgModule({
  declarations: [CapFormFieldComponentComponent],
  imports: [
    RouterModule.forChild(routes),
    MaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [RouterModule, CapFormFieldComponentComponent],
})
export class ShiftDailyCapRoutingModule {}
